/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { CarrierProfileFragmentDoc } from './CarrierProfileFragment'
import { CarrierRelationshipInfoFragmentDoc } from './CarrierRelationshipInfoFragment'
export type ICarrierPageFragment = { __typename?: 'CarrierApplication' } & Pick<
  Types.ICarrierApplication,
  | 'id'
  | 'deletedAt'
  | 'dotNumber'
  | 'fmcsaRating'
  | 'isTrusted'
  | 'mcNumber'
  | 'name'
  | 'state'
  | 'totalShipments'
> & {
    primaryCarrierManager?: Types.Maybe<
      { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>
    >
    carrierRelationships: Array<
      { __typename?: 'CarrierRelationship' } & Pick<
        Types.ICarrierRelationship,
        'id' | 'relationshipType' | 'relationshipLevel'
      > & { user: { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'> }
    >
    carrierProfile?: Types.Maybe<
      { __typename?: 'CarrierProfile' } & Pick<
        Types.ICarrierProfile,
        'excludedCommodities' | 'endorsements'
      > & {
          certifications: Array<
            { __typename?: 'CarrierCertification' } & Pick<
              Types.ICarrierCertification,
              'certificationId' | 'code' | 'issuingOrganization' | 'isVerified' | 'renewalDate'
            >
          >
          dedicatedLaneRatePreference?: Types.Maybe<
            { __typename?: 'CarrierDedicatedLaneRatePreference' } & Pick<
              Types.ICarrierDedicatedLaneRatePreference,
              'id' | 'isInterestedInDedicatedLanes' | 'minimumRatePerMile'
            >
          >
          loadingCapability?: Types.Maybe<
            { __typename?: 'CarrierLoadingCapability' } & Pick<
              Types.ICarrierLoadingCapability,
              'id' | 'isLiveCapable' | 'isDropCapable' | 'isHeavyLoadCapable' | 'isPowerOnly'
            >
          >
          rateTypePreference?: Types.Maybe<
            { __typename?: 'CarrierRateTypePreference' } & Pick<
              Types.ICarrierRateTypePreference,
              'id' | 'allowsAllIn' | 'allowsDayRate' | 'hasLineHaulFuelSurcharge'
            >
          >
          smartWayRegistration?: Types.Maybe<
            { __typename?: 'CarrierSmartWayRegistration' } & Pick<
              Types.ICarrierSmartWayRegistration,
              'id' | 'isRegistered' | 'renewalDate'
            >
          >
          equipmentCapability?: Types.Maybe<
            { __typename?: 'CarrierEquipmentCapability' } & Pick<
              Types.ICarrierEquipmentCapability,
              | 'id'
              | 'isDryVanCapable'
              | 'isFlatbedCapable'
              | 'isReeferCapable'
              | 'isTrailerOnly'
              | 'powerUnitCount'
              | 'trailerCount'
            >
          >
          freightCapability?: Types.Maybe<
            { __typename?: 'CarrierFreightCapability' } & Pick<
              Types.ICarrierFreightCapability,
              'id' | 'isDrayageCapable' | 'isFtlCapable' | 'isIntermodalCapable' | 'isLtlCapable'
            >
          >
        }
    >
  }

export const CarrierPageFragmentDoc = gql`
  fragment CarrierPage on CarrierApplication {
    id
    ...CarrierProfile
    deletedAt
    dotNumber
    fmcsaRating
    isTrusted
    mcNumber
    name
    primaryCarrierManager {
      id
      fullName
    }
    carrierRelationships {
      ...CarrierRelationshipInfo
    }
    state
    totalShipments
  }
  ${CarrierProfileFragmentDoc}
  ${CarrierRelationshipInfoFragmentDoc}
`
